// Simple EventBus compatible with Vue 2-style API used in codebase
// Mirrors: EventBus.$on, EventBus.$emit, EventBus.$off
const listeners = new Map();

export const EventBus = {
  $on(type, handler) {
    const handlers = listeners.get(type);
    if (handlers) {
      handlers.push(handler);
    } else {
      listeners.set(type, [handler]);
    }
  },
  $off(type, handler) {
    const handlers = listeners.get(type);
    if (handlers) {
      listeners.set(type, handlers.filter(h => h !== handler));
    }
  },
  $emit(type, ...args) {
    const handlers = listeners.get(type);
    if (handlers) {
      handlers.slice().forEach(handler => handler(...args));
    }
  },
  // also support .on/.off/.emit (mitt-style)
  on(type, handler) { this.$on(type, handler); },
  off(type, handler) { this.$off(type, handler); },
  emit(type, ...args) { this.$emit(type, ...args); },
};
